module.exports = __webpack_public_path__ + "static/media/sumar.615ede5b.svg";